let products = null;

export const getCachedProducts = () => products;

export const setCachedProducts = (list) => {
  products = list;
};
